export function openUrl(url) {
  url = url.replace(/\s*/g, '')
  if (url.indexOf('http://') != 0 && url.indexOf('https://') != 0) {
    url = 'https://' + url
  }
  window.open(url, '_blank')
}
